// extracted by mini-css-extract-plugin
export default {"diagram-block":"styles_diagram-block__2Tad0","header":"styles_header__l2JkR","chart":"styles_chart__-v0hA","loader":"styles_loader__s8EU0","title":"styles_title__kb6Ud"};